import { OnboardingModeEnum } from 'modules/onboarding/types/onboarding-mode.enum';
import { useCallback } from 'react';
import { useUpdateOnboardingModeMutation } from 'shared/hooks/api/updateOnboardingMode/updateOnboardingMode.generated';
import { useOnboardingStore } from 'shared/hooks/stores/useOnboardingStore';

export const useOnboardingMode = () => {
  const onboardingMode = useOnboardingStore((state) => state.mode);
  const setOnboardingMode = useOnboardingStore((state) => state.setOnboardingMode);

  const [updateOnboardingModeMutation, { loading }] = useUpdateOnboardingModeMutation();

  const updateOnboardingMode = useCallback(
    async (mode: OnboardingModeEnum, startExtraction = false, updateApi = true) => {
      setOnboardingMode(mode, startExtraction);
      if (updateApi) {
        return updateOnboardingModeMutation({
          variables: {
            onboardingMode: mode,
          },
        });
      }
      return 'Success';
    },
    [setOnboardingMode],
  );

  return {
    onboardingMode,
    updateOnboardingMode,
    loading,
  };
};
